<template>
  <v-autocomplete
    :items="productLines"
    item-text="name"
    item-value="id"
    :value="productLine"
    :label="label"
    :loading="loading"
    :required="required"
    :error-messages="errorMessages"
    :disabled="loading"
    outlined
    clearable
    @change="handleSelect"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content
        class="v-list-item__content"
        data-test="product-line-item"
      >
        <v-list-item-title v-text="item.name"></v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { getProductLines } from "@/services/products/product_lines.js";

export default {
  name: "select-product-line",

  props: {
    productLine: [Number, String, Object],
    label: {
      type: String,
      default: "Linha de produto",
    },
    errorMessages: [String, Array],
    required: Boolean,
  },

  data: () => ({
    productLines: [],
    loading: false,
  }),

  model: {
    prop: "productLine",
    event: "change",
  },

  methods: {
    async fetchProductLines() {
      this.loading = true;

      try {
        const response = await getProductLines();

        this.productLines = response;
      } finally {
        this.loading = false;
      }
    },

    handleSelect(value) {
      this.$emit("change", value);
    },
  },

  created() {
    this.fetchProductLines();
  },
};
</script>
